import styles from './ProgressIndicator.module.css';

export type ProgressStep = 1 | 2 | 3;

interface ProgressIndicatorProps {
  currentStep: ProgressStep;
  onStepClick?: (step: ProgressStep) => void;
}

const steps = [
  { number: 1 as ProgressStep, label: 'Design', description: 'Create your design' },
  { number: 2 as ProgressStep, label: 'Pricing', description: 'Select quantity & pricing' },
  { number: 3 as ProgressStep, label: 'Checkout', description: 'Complete order' },
];

export const ProgressIndicator = ({
  currentStep,
  onStepClick,
}: ProgressIndicatorProps) => {
  return (
    <div className={styles.progressIndicator}>
      {steps.map((step, index) => (
        <div key={step.number} className={styles.stepContainer}>
          <div
            className={`${styles.step} ${
              currentStep >= step.number ? styles.active : ''
            } ${currentStep > step.number ? styles.completed : ''}`}
            onClick={() => onStepClick?.(step.number)}
            role={onStepClick ? 'button' : undefined}
            tabIndex={onStepClick ? 0 : undefined}
          >
            <div className={styles.stepNumber}>
              {currentStep > step.number ? (
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="3"
                >
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              ) : (
                step.number
              )}
            </div>
            <div className={styles.stepContent}>
              <div className={styles.stepLabel}>{step.label}</div>
              <div className={styles.stepDescription}>{step.description}</div>
            </div>
          </div>
          {index < steps.length - 1 && (
            <div
              className={`${styles.connector} ${
                currentStep > step.number ? styles.completed : ''
              }`}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default ProgressIndicator;
